import store from 'store';
import { APP_ROLES } from 'store/enums';
import {
  TRANSPORT_GET_MASTER_DATA,
  GET_REQUIRED_DOCUMENTATION,
  GET_REQUIRED_DOCUMENTATION_OFFLINE,
  GET_REQUIRED_IMAGES_OFFLINE,
  SET_TRANSPORT_PROPERTY
} from 'store/actions/transport';
import { ACT_CMS } from 'store/actions/act';
import { UI_GET_CHEKINOUT_MASTER_DATA } from 'store/actions/ui';
import { lsGetAct, lsGetTransferAct } from 'helpers/store';

const Layout = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/layout-transportation" */ 'views/modules/Transport/LayoutTransport'
  );
const TransportationList = () =>
  import(/* webpackChunkName: "pages/views/modules/transport" */ 'views/modules/Transport');
const TransportActClient = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/transport-act/client-act" */ 'views/modules/Transport/TransportAct/ClientAct'
  );
const TransportActTranfe = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/transport-act/tranfe-act" */ 'views/modules/Transport/TransportAct/TransferAct'
  );
const TransportOfflineDocuments = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/transport-act/tranfe-act" */ 'views/modules/Transport/TransportOfflineDocuments'
  );
const ClientSign = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/client/sign" */ 'views/modules/Transport/TransportAct/ClientAct/Sign'
  );
const TransferSign = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/transfer/sign" */ 'views/modules/Transport/TransportAct/TransferAct/Sign'
  );
const TransportSignComplete = () =>
  import(
    /* webpackChunkName: "pages/views/modules/transport/shared/sign-completed"  */ 'views/modules/Transport/shared/SignCompleted'
  );

const OkData = () =>
  import(
    /* webpackChunkName: "pages/views/modules/Transport/TransportAct/shared/OkData" */ 'views/modules/Transport/TransportAct/shared/OkData'
  );

// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

export default [
  {
    path: '/transportation',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'list' // Redirige a la ruta 'list' por defecto
      },
      {
        path: 'list',
        component: TransportationList,
        name: 'transportationList',
        meta: {
          titleKey: 'transportationList',
          requiresAuth: true,
          roles: [
            APP_ROLES.CAMPS_MANAGER,
            APP_ROLES.TRANSPORTATION_MANAGER,
            APP_ROLES.CAMPS_COORDINATOR,
            APP_ROLES.LOGISTICS_DRIVER
          ]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`transport/${TRANSPORT_GET_MASTER_DATA}`)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, TRANSPORT_GET_MASTER_DATA);
            });
        }
      },
      {
        path: 'act-client/:plate([0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3})',
        name: 'transport-act-client',
        component: TransportActClient,
        meta: {
          titleKey: 'act',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant'
            }),
            store.dispatch(`transport/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-concession'
            }),
            store.dispatch(`transport/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-damage'
            })
          ];
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, TRANSPORT_GET_MASTER_DATA); // Cambiar CAMPS_GET_MASTER_DATA
            });
        }
      },
      {
        path: 'act-transfer/:plate([0-9]{4}[BCDFGHJKLMNPRSTVWXYZ]{3})',
        name: 'transport-act-transfer',
        component: TransportActTranfe,
        meta: {
          titleKey: 'act',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant'
            }),
            store.dispatch(`transport/${GET_REQUIRED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'checkinout-damage'
            })
          ];
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, TRANSPORT_GET_MASTER_DATA); // Cambiar CAMPS_GET_MASTER_DATA
            });
        }
      },
      {
        path:
          ':transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/client/sign',
        name: 'transport-client-sign',
        component: ClientSign,
        meta: {
          titleKey: 'signData',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          const partnerId = to.params.partnerId || process.env.DEFAULT_PARTNER;
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'driver-summary'
            })
          ];
          if (
            to.name === 'transport-client-sign' &&
            !store.getters['transport/data']('act') &&
            lsGetAct()
          ) {
            promises.push(
              store.dispatch(`transport/${SET_TRANSPORT_PROPERTY}`, {
                field: 'act',
                value: lsGetAct()
              })
            );
          }
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          ':transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/transfer/sign',
        name: 'transport-transfer-sign',
        component: TransferSign,
        meta: {
          titleKey: 'signData',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          const partnerId = to.params.partnerId || process.env.DEFAULT_PARTNER;
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'driver-summary'
            })
          ];
          if (
            to.name === 'transport-transfer-sign' &&
            !store.getters['transport/data']('act') &&
            lsGetTransferAct()
          ) {
            promises.push(
              store.dispatch(`transport/${SET_TRANSPORT_PROPERTY}`, {
                field: 'act',
                value: lsGetTransferAct()
              })
            );
          }
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          'completed/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/ok',
        name: 'transport-sign-completed',
        component: TransportSignComplete,
        meta: {
          titleKey: 'signCompleted',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          const partnerId = to.params.partnerId || process.env.DEFAULT_PARTNER;
          store
            .dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'driver-sign'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          'document-offline/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
        name: 'upload-document-offline',
        component: TransportOfflineDocuments,
        meta: {
          titleKey: 'uploadDocumentOffline',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`ui/${UI_GET_CHEKINOUT_MASTER_DATA}`),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant'
            }),
            store.dispatch(`transport/${GET_REQUIRED_DOCUMENTATION_OFFLINE}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER
            }),
            store.dispatch(`transport/${GET_REQUIRED_IMAGES_OFFLINE}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER
            })
          ];
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, TRANSPORT_GET_MASTER_DATA); // Cambiar CAMPS_GET_MASTER_DATA
            });
        }
      },
      {
        path: 'ok-data',
        name: 'ok-data-transport',
        component: OkData,
        meta: {
          titleKey: 'okData',
          requiresAuth: true,
          roles: [APP_ROLES.CAMPS_MANAGER, APP_ROLES.LOGISTICS_DRIVER]
        },
        beforeEnter(to, from, next) {
          store
            .dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId || process.env.DEFAULT_PARTNER,
              patternId: 'grant-ok'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      }
    ]
  }
];
